// Shared "recent colours" store — a single global (per-user) MRU list used by
// every colour picker in the app, like Office/Figma. Newest first, capped.
import { getUserScopedJSON, setUserScopedJSON } from './userScopedStorage';

const KEY = 'pidly.recentColors';
const MAX = 10;

// Normalise to lowercase #rrggbb so the same colour from different inputs
// (e.g. #FFF vs #ffffff) doesn't appear twice.
export function normalizeColor(c) {
  if (typeof c !== 'string') return null;
  let s = c.trim().toLowerCase();
  const m3 = s.match(/^#?([0-9a-f]{3})$/);
  if (m3) s = '#' + m3[1].split('').map(ch => ch + ch).join('');
  else if (/^[0-9a-f]{6}$/.test(s)) s = '#' + s;
  return /^#[0-9a-f]{6}$/.test(s) ? s : (s.startsWith('#') ? s : null);
}

export function getRecentColors() {
  const list = getUserScopedJSON(KEY, []);
  return Array.isArray(list) ? list.filter(Boolean).slice(0, MAX) : [];
}

// Push a colour to the front (de-duped), persist, and return the new list.
export function addRecentColor(color) {
  const c = normalizeColor(color);
  if (!c) return getRecentColors();
  const next = [c, ...getRecentColors().filter(x => x !== c)].slice(0, MAX);
  setUserScopedJSON(KEY, next);
  // Let any other mounted pickers refresh their recents immediately.
  try { window.dispatchEvent(new CustomEvent('pidly:recent-colors-updated')); } catch { /* SSR */ }
  return next;
}
